import React, { Component } from "react";
import "./css/RoadmapMessage.css";

class RoadmapMessage extends Component {

    render() {
        return (
            <>
                <div className="title title-thin title-xl-2">
                    <h1>Roadmap</h1>
                </div>
                <div className="lead-s2 lead-light">
                    Our roadmap is a
                    planned where we take on the most complex problems and turn them into great
                    solutions
                </div>
            </>
        );
    }
}

export default RoadmapMessage;